import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { UserDetails } from '../../interfaces/User/UserDetails';
import { generateAffiliateCode } from '../../utils/Affiliate';
import { updateAffiliateProgramForUser } from '../../api/User';
import { Waiting } from '../../components/Waiting/Waiting';
import { sharedColors, sharedStyles } from '../../utils/Style';

type ConvertToAffiliateDialogProps = {
  user?: UserDetails;
  open: boolean;
  onClose: () => void;
  onConvert: () => void;
};

export const ConvertToAffiliateDialog = ({
  user,
  open,
  onClose,
  onConvert,
}: ConvertToAffiliateDialogProps) => {
  const [loading, setLoading] = useState(false);
  const [affiliateCode, setAffiliateCode] = useState('');

  useEffect(() => {
    setAffiliateCode(
      user?.affiliateCode ??
        generateAffiliateCode(user?.firstName ?? '', user?.lastName ?? ''),
    );
  }, [user]);

  const onConfirm = () => {
    if (!user) return;

    setLoading(true);
    updateAffiliateProgramForUser(user.id, affiliateCode)
      .then(() => {
        toast.success('Kullanıcı başarıyla partner hesabına çevrildi');
        onConvert();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  const hasExistingAffiliateCode = !!user?.affiliateCode;

  return (
    <Dialog open={open} onClose={onClose}>
      <Waiting open={loading} />
      <DialogTitle sx={{ ...sharedStyles.h6, color: sharedColors.gray6 }}>
        Partner hesabına çevir
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <TextField
          label='Affiliate Kodu'
          disabled={hasExistingAffiliateCode}
          value={affiliateCode}
          onChange={(e) => setAffiliateCode(e.target.value)}
          helperText='Kod oluşturulduktan sonra değiştirilemez'
          sx={{ mt: 1.5, width: 350 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 1.5 }}>
        <Button
          variant='contained'
          color='inherit'
          onClick={onClose}
          sx={sharedStyles.buttonText}
        >
          İptal
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={onConfirm}
          sx={sharedStyles.buttonText}
        >
          Onayla
        </Button>
      </DialogActions>
    </Dialog>
  );
};
